<style lang="scss">
  #modal-automation-send {
    .schedule {
      margin-top: 5px;

      input {
        height: 30px;
        border-radius: 2px;
        border: 1px solid #eee;
        padding: 5px;

        &.date {
          width: 80px;
        }

        &.time {
          width: 50px;
        }
      }
    }

    .details {
      color: #333;
    }

    code {
      display: inline;
    }

    .modal-dialog {
      width: 100%;
      max-width: 808px;
      min-width: 415px;
    }
  }
</style>

<style lang="scss">
  @import '../../../sass/variables';

  #modal-automation-send {
    .modal-body {
      background-color: $salesflow-bg-content;
    }
  }

  .automation-send {
    text-align: center;
    font-weight: 500;
    max-width: 440px;
    margin: 0 auto;
    font-family: 'Montserrat', sans-serif;
    line-height: 25px;
    letter-spacing: -.2px;

    &__title {
      font-size: 20px;
      letter-spacing: -.3px;
      color: #3b334a;
    }

    &__help {
      font-size: 13px;
      color: #3b334a;
      margin-bottom: 24px;
    }

    &__total {
      margin: 12px 0;
      font-size: 13px;
      color: #857a98;

      span {
        color: #3b334a;
        font-weight: 700;
      }
    }

    &__control {
      display: flex;
      align-items: center;
      justify-content: center;

      &--fix-margin {
        margin-left: -22px;
      }
    }

    &__radio {
      cursor: pointer;
      margin-right: 10px;
      position: relative;

      &::before {
        top: -2px;
        left: -2px;
        content: '';
        width: 16px;
        height: 16px;
        border-radius: 50%;
        position: absolute;
        pointer-events: none;
        background-color: #FFF;
        border: 1px solid #7123db;
      }

      &:checked::after {
        top: 2px;
        left: 2px;
        width: 8px;
        height: 8px;
        content: '';
        border-radius: 50%;
        position: absolute;
        pointer-events: none;
        background-color: #7123db;
      }
    }

    &__time {
      width: 170px;
      margin-right: 6px;
      margin-bottom: 16px;
      display: inline-block;
    }

    &__cancel {
      display: block;
    }

    &__label {
      margin: 0;
      color: #3b334a;
      text-align: left;
    }

    &__schedule {
      margin-bottom: 20px;

      &-action {
        color: #3b334a;
        text-decoration: underline;
      }
    }
  }
</style>

<template>
  <BModal
    id="modal-automation-send"
    ref="modal-automation-send"
    hide-footer="hide-footer"
  >
    <template slot="modal-title">
      {{ __('Enviar campanhas') }}
    </template>
    <div
      class="automation-send"
      slot="default"
    >
      <h3 class="automation-send__title">
        {{ automation.name }}
      </h3>
      <p class="automation-send__help">
        {{ __('Selecione abaixo as opções para enviar sua campanha') }}
      </p>
      <div class="automation-send__control automation-send__control--fix-margin">
        <input
          class="automation-send__radio"
          type="radio"
          name="type"
          value="all"
          v-model="type"
        >
        <label
          class="automation-send__label"
          for="type-all"
        >{{ __('Enviar para toda a base') }}</label>
      </div>
      <div class="automation-send__control">
        <input
          class="automation-send__radio"
          type="radio"
          name="type"
          value="some"
          v-model="type"
        >
        <label
          class="automation-send__label"
          for="type-some"
        >{{ __('Enviar para segmentação...') }}</label>
      </div>
      <div
        class="form-group"
        v-show="type === 'some'"
      >
        <div class="search-recipient">
          <Multiselect
            id="search-recipient"
            label="name"
            track-by="id"
            v-model="recipient"
            :placeholder="__('Digite para pesquisar segmentação')"
            :loading="searching"
            :options="options"
            :multiple="false"
            :searchable="true"
            :show-labels="false"
            :hide-selected="true"
            :preserve-search="true"
            :internal-search="false"
            :show-no-options="false"
            :show-no-results="false"
            @select="selectRecipient"
            @search-change="search"
          />
        </div>
      </div>
      <div class="form-group details">
        <p class="automation-send__total">
          {{ __('Total de destinatários:') }}
          <span v-if="! counting"> {{ recipientCount | number(0) }}</span><span v-else><i class="fa fa-circle-o-notch fa-spin" /></span>
        </p>
        <div class="automation-send__schedule">
          <span v-if="! schedule.active"><a
            class="automation-send__schedule-action"
            href="javascript:;"
            @click="schedule.active = true"
          > {{ __('Definir agendamento') }}</a></span><span v-else>
            <div class="automation-send__time">
              <p class="automation-send__label">{{ __('Agendar para') }}</p>
              <InputDateTimepicker
                v-model="schedule.date"
              />
            </div>
            <div class="automation-send__time">
              <p class="automation-send__label">{{ __('Às') }}</p>
              <InputDateTimepicker
                type="time"
                v-model="schedule.time"
                input-class="form-control"
              />
            </div><a
              class="text-danger automation-send__cancel"
              href="javascript:;"
              @click="schedule.active = false"
            >{{ __('Cancelar') }}</a></span>
        </div>
      </div>
      <div class="form-actions text-center">
        <button
          class="btn btn-primary"
          type="submit"
          :disabled="disabled"
          @click="send()"
        >
          <span v-if="sending"><i class="fa fa-circle-o-notch fa-spin" /></span><span v-else>{{ schedule.active ? __('Agendar') : __('Enviar agora') }}</span>
        </button>
      </div>
    </div>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  props: ['user', 'automation', 'show', 'all'],

  created () {
    this.search();
  },

  data () {
    return {
      sending: false,
      counting: false,
      searching: false,
      type: '',
      options: [],
      recipient: null,
      recipients: '',
      recipientCount: 0,
      schedule: {
        active: false,
        date: new Date(),
        time: new Date(),
      },
    };
  },

  watch: {
    show (show) {
      if (show) {
        this.$emit('opened');

        return this.openModal();
      }
    },

    type () {
      if (this.type === 'all') {
        return this.count('all');
      }

      if (this.type === 'some' && this.recipients.length) {
        return this.count(this.recipients);
      }

      this.recipientCount = 0;
    },
  },

  computed: {
    disabled () {
      return this.recipientCount == 0 || this.sending;
    },
  },

  methods: {
    openModal () {
      this.$refs['modal-automation-send'].show();
    },

    hideModal () {
      this.$refs['modal-automation-send'].hide();
    },

    selectRecipient (recipient) {
      this.setRecipients(recipient.relation);
    },

    setRecipients (recipients) {
      this.recipients = recipients;

      if (this.recipients.length) {
        return this.count(this.recipients.split(','));
      }

      this.recipientCount = 0;
    },

    search (query = '') {
      this.searching = true;

      this.$http.get(`/automation/recipient/search?query=${query}`)
        .then(({ data }) => {
          this.options = data;
        })
        .finally(() => {
          this.searching = false;
        });
    },

    count (recipients) {
      this.counting = true;

      this.$http.get(`/automation/recipient/count?recipients=${recipients}`)
        .then(({ data }) => {
          this.recipientCount = data;
        })
        .finally(() => {
          this.counting = false;
        });
    },

    send () {
      const recipients = this.recipients.split(',');

      if ((! this.schedule.active && this.recipientCount == 0) || (this.type !== 'all' && ! recipients.length)) {
        Alert.error(this.__('Nenhum destinatário encontrado.'));

        return;
      }

      const data = {
        schedule_date: this.schedule.date,
        schedule_time: this.schedule.time,
        recipient_count: this.recipientCount,
        schedule_active: this.schedule.active,
        recipients: this.type === 'all' ? 'all' : recipients,
      };

      this.sending = true;

      this.$http.post(`/automation/${this.automation.id}/sending`, data)
        .then(() => {
          this.hideModal();

          Alert.info(this.__('Campanha agendada.'));

          Bus.$emit('campaignScheduled');
        })
        .catch((response) => {
          if (response.status === 422) {
            return Alert.error(response.data[Object.keys(response.data)][0]);
          }

          Alert.error(this.__('Erro ao enviar campanha. Tente novamente mais tarde.'));
        })
        .finally(() => {
          this.sending = false;
        });
    },
  },
};
</script>
